<template>
  <div v-if="show">

    <wxc-countdown
      v-if="!callAndVerifyCountdownCompleted"
      v-show="false"
      tpl="{s}"
      :time="callAndVerifyCountdownTime"
      @wxcOnComplete="callAndVerifyCountdownCompleted=true"
      @countdownDetails="callAndVerifyCountdownRemainingSeconds=$event.second"
      ></wxc-countdown>

    <div class="input_container">
      <weex-text class="input_label">{{otpLabel}}</weex-text>
      <input
        class="input_with_border_bottom"
        type="number"
        maxlength="6"
        :value="otp"
        @input="otp=$event.target.value">
    </div>


    <div class="margin-top-10 margin-left-10 margin-right-10">
      <weex-text>
        <span class="font-size-sm text-color-blue">Did not receive OTP?</span>
        <span
          v-if="!countdownCompleted"
          class="font-size-sm text-color-blue">&nbsp;Resend OTP in
        </span>
        <span
          v-if="!countdownCompleted"
          class="font-size-sm text-color-blue">{{countdownRemainingSeconds}} second(s).
        </span>
        <span
          @click="onSendOTPClicked"
          v-if="countdownCompleted"
          class="item-sm-link">Click here
        </span>
        <span
          v-if="countdownCompleted"
          class="font-size-sm text-color-blue">to resend OTP.
        </span>
      </weex-text>
      <wxc-countdown
        v-if="!countdownCompleted"
        v-show="false"
        tpl="{s}"
        :time="countDowntime"
        @wxcOnComplete="countdownCompleted=true"
        @countdownDetails="countdownRemainingSeconds=$event.second"
        ></wxc-countdown>
    </div>

    <wxc-button
      :text="loginText"
      class="horizontal_center margin-top-30"
      type="blue"
      @wxcButtonClicked="onLoginClicked"
      ></wxc-button>

    <div v-if="showCallAndVerifyOption">
      <weex-text
        class="margin-top-10 text-align-center font-weight-bold text-color-gray">
        -OR-
      </weex-text>

      <wxc-button
        v-if="!isCallAndVerifyEnabled"
        :text="callAndVerifyButtonText"
        :btn-style="callAndVerifyDisabledButtonStyle"
        :text-style="callAndVerifyDisabledTextStyle"
        class="horizontal_center margin-top-10">
      </wxc-button>

      <wxc-button
        v-if="isCallAndVerifyEnabled"
        :text="callAndVerifyButtonText"
        class="horizontal_center margin-top-10"
        type="blue"
        @wxcButtonClicked="onCallAndVerifyClicked"
        ></wxc-button>
    </div>
  </div>
</template>

<script>

  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import WxcCountdown from "../../../weex-ui/packages/wxc-countdown/index";
  import EzUtils from "../../utils/EzUtils";
  import AlertService from "../core/alert/AlertService";
  import { MessageConstants } from "../../utils/MessageConstantUtil";
  import { environment } from "../../environments/environment";

  export default {
    name: 'CallAndVerifyView',
    components: { WxcButton, WxcCountdown },

    data: () => ({
      otp: "",
      countdownCompleted: false,
      countdownRemainingSeconds: "",
      countDowntime: "",
      callAndVerifyCountdownCompleted: false,
      callAndVerifyCountdownRemainingSeconds: "",
      callAndVerifyCountdownTime: ""
    }),

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },

      otpLabel: {
        type: String,
        default: "OTP"
      },

      showCallAndVerifyOption: {
        type: Boolean,
        default: true
      },

      loginText: {
        type: String,
        default: "Login"
      },

      callAndVerifyText: {
        type: String,
        default: "Call and Verify"
      },

      resendOTPTime: {
        type: Number,
        default: 30 * 1000 //30 seconds
      },

      callAndVerifyTime: {
        type: Number,
        default: 60 * 1000 //60 seconds
      }
    },

    methods: {
      showSMSOTPView() {
        this.otp = "";
        this.countdownCompleted = false;
        this.countdownRemainingSeconds = "";
        this.countDowntime = new Date().getTime() + this.resendOTPTime;
        if (!this.callAndVerifyCountdownTime) {
          this.callAndVerifyCountdownTime = new Date().getTime() + this.callAndVerifyTime;
        }
      },

      showToast(message) {
        AlertService.showToast(message);
      },

      onLoginClicked() {
        if (EzUtils.containsOnlyNumbers(this.otp)) {
          this.$emit("onLoginClicked", { otp: this.otp });
        } else {
          this.showToast(MessageConstants.INVALID_OTP_MESSAGE);
        }
      },

      onCallAndVerifyClicked() {
        this.$emit("onCallAndVerifyClicked")
      },

      onSendOTPClicked() {
        this.$emit("onSendOTPClicked")
      }
    },

    computed: {
      isCallAndVerifyEnabled() {
        return this.callAndVerifyCountdownCompleted && environment.callAndVerifyEnabled;
      },

      callAndVerifyDisabledButtonStyle() {
        return { "background-color": "#D0D0D0" }
      },

      callAndVerifyDisabledTextStyle() {
        return { color: "#FFFFFF" }
      },

      callAndVerifyButtonText() {
        return this.callAndVerifyCountdownCompleted
          ? this.callAndVerifyText
          : `${this.callAndVerifyText} in ${this.callAndVerifyCountdownRemainingSeconds} second(s)`;
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
